import { FrontUrls } from 'Constants/FrontUrls'
import React, { lazy } from 'react'
import { LazyRoute, filtersSlice, PAGE_SLUG } from 'Modules'
import { Switch } from 'react-router-dom'
import { useUnmount } from 'Src/hooks/useUnmount'
import { useAppDispatch } from 'Src/hooks'

const BankEmployeesListLazy = lazy(
	() => import('Pages/bankEmployees/components/BankEmployeesList/index')
)

const actions = {
	clearFilters: filtersSlice.actions.clearFilters,
}

export const BankEmployeesRoutes = () => {
	const { clearFilters } = useAppDispatch(actions)
	useUnmount(() => {
		clearFilters(PAGE_SLUG.BANK_EMPLOYEES)
	})
	return (
		<Switch>
			<LazyRoute
				exact
				path={FrontUrls.bank_employees}
				lazyComponent={BankEmployeesListLazy}
				key={FrontUrls.bank_employees}
			/>
		</Switch>
	)
}
